// src/components/GlobalAlertGate.jsx
import React, { useEffect, useState } from "react";
import AlertBanner from "./AlertBanner";
import BASE_URL from "../config";

const STATUS_URL = `${BASE_URL}/status`; // optional backend endpoint you add
const HEALTH_URL = `${BASE_URL}/health`; // you already have /api/health; adjust if needed

export default function GlobalAlertGate() {
  const [statusAlert, setStatusAlert] = useState(null); // from /status
  const [downAlert, setDownAlert] = useState(null);     // from /health ping

  // 1) Scheduled messages (one-shot fetch)
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await fetch(STATUS_URL, { cache: "no-store" });
        if (!res.ok) return;
        const data = await res.json();
        // Expected shape:
        // { active: true, id: "maint-2025-09-12",
        //   type: "maintenance", title: "Maintenance",
        //   message: "SynthGuard will be down ...",
        //   start: "2025-09-12T00:00:00Z", end: "2025-09-12T02:00:00Z" }
        if (mounted && data?.active) setStatusAlert(data);
      } catch {
        /* ignore */
      }
    })();
    return () => { mounted = false; };
  }, []);

  // 2) Health ping (poll)
  useEffect(() => {
    let timer;
    let cancelled = false;

    const ping = async () => {
      try {
        const res = await fetch(HEALTH_URL, { cache: "no-store" });
        if (!res.ok) throw new Error("bad status");
        if (!cancelled) setDownAlert(null);
      } catch {
        if (!cancelled) {
          setDownAlert({
            id: "backend-down",
            type: "down",
            title: "Alert: Application Down",
            message: "The backend appears to be unreachable. We’re working to restore service.",
          });
        }
      } finally {
        timer = setTimeout(ping, 30000); // every 30s
      }
    };

    ping();
    return () => { cancelled = true; clearTimeout(timer); };
  }, []);

  // Prefer scheduled maintenance if both are present
  const active = statusAlert ?? downAlert;
  if (!active) return null;

  return (
    <AlertBanner
      id={active.id}
      type={active.type || "info"}
      title={active.title}
      message={active.message}
      start={active.start}
      end={active.end}
    />
  );
}
